/* global window */
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listOrders, getOrder, getOrderByEmailOrderNumber } from './api';
import {
  LIST_ORDERS_REQUEST,
  GET_ORDER_REQUEST,
  GET_ORDER_BY_EMAIL_ORDERNUMBER_REQUEST,
  GET_ORDER_SUCCESS,
  ORDER_REQUESTING,
  LIST_ORDERS_SUCCESS,
  RESET_ORDER_ISFETCHING
} from './constants';

export function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: ORDER_REQUESTING });
    const response = yield call(listOrders, customerId(), action.queryString);
    yield put({ type: LIST_ORDERS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: RESET_ORDER_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* getO(action) {
  // Also called from club process - ship it now function
  try {
    yield call(removeAPIError);
    yield put({ type: ORDER_REQUESTING });
    if (!Cookies.get('customerToken')) {
      window.location.href = `/profile/login`;
    }
    const response = yield call(getOrder, customerId(), action.orderId);
    yield put({ type: GET_ORDER_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: RESET_ORDER_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* getByEmailOrderNumber(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: ORDER_REQUESTING });
    const response = yield call(
      getOrderByEmailOrderNumber,
      action.email,
      action.orderNumber
    );
    yield put({ type: GET_ORDER_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: RESET_ORDER_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* watchList() {
  yield takeLatest(LIST_ORDERS_REQUEST, list);
  yield takeLatest(GET_ORDER_REQUEST, getO);
  yield takeLatest(
    GET_ORDER_BY_EMAIL_ORDERNUMBER_REQUEST,
    getByEmailOrderNumber
  );
}

export default function* orderSagas() {
  yield all([watchList()]);
}

const customerId = () => jwtDecode(Cookies.get('customerToken')).sub;
